import { faDownload } from '@fortawesome/free-solid-svg-icons';

import { ButtonSizeVariants, ButtonVariants } from 'constants/common';
import { Button, Input } from 'shared-components';

type Props = {
  title: string;
  onTitleChange: (v: string) => void;
};

const ReportDocumentHeader = ({ title, onTitleChange }: Props) => {
  return (
    <div className="grid grid-cols-[1fr_auto] items-center h-12 px-5 py-1 bg-white dark:bg-black-900 border-b border-neutral-200 dark:border-neutral-800">
      <Input
        className="w-[16.875rem] border-none outline-none bg-transparent text-gray-900"
        inputClassName="!text-xl !h-8 !text-neutral-500 border-none"
        value={title}
        onChange={(e) => onTitleChange(e.target.value)}
      />
      <div className="flex gap-2">
        <Button type="button" size={ButtonSizeVariants.MD} variant={ButtonVariants.PRIMARY}>
          Preview
        </Button>
        <Button type="button" size={ButtonSizeVariants.MD} variant={ButtonVariants.OUTLINE} rightIcon={faDownload}>
          Download
        </Button>
      </div>
    </div>
  );
};

export default ReportDocumentHeader;
